/**
 * @ngdoc directive
 * @name cbl.finanza.mf.directive:finanzaSaldoDossier
 * @restrict E
 * @scope
 * @description Componente rappresentante il dettaglio del saldo dossier
 * @param {String} sceltaDossierState - Nome dello stato per la scelta del dossier
 * @param {String} visualizzaRaccomandazioneState - Nome dello stato per andare nella sezione di visualizzazione di una raccomandazione
 * @param {String} modificaRaccomandazioneState - Nome dello stato per andare nella sezione di modifica di una raccomandazione
 * @param {String} nuovaRaccomandazioneState - Nome dello stato per andare nella sezione di creazione di una raccomandazione
 * @param {String} rifiutaRaccomandazioneState - Nome dello stato in cui navigare dopo aver rifiutato una raccomandazione
 * @param {String} accettaRaccomandazioneState - Nome dello stato in cui navigare dopo aver accettato una raccomandazione
 * @param {String} sceltaDossierState - Nome dello stato in cui è contenuta la lista dei dossiers
 */
(function () {
  'use strict';
  var SaldoDossierCtrl = function (
    $http,
    $scope,
    $window,
    $q,
    $stateParams,
    $state,
    $location,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    uiGridConstants,
    messaggiSrvc,
    userSrvc,
    $uibModal,
    brioSrvc,
    deskSrvc
  ) {
    var self = this;
    this.$uibModal = $uibModal;
    this.$http = $http;
    this.$window = $window;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.$location = $location;
    this.messaggiFctr = messaggiFctr;
    this.messaggiSrvc = messaggiSrvc;
    this.userSrvc = userSrvc;
    this.brioSrvc = brioSrvc;
    this.deskSrvc = deskSrvc;
    $scope.msg = labelSrvc.getLabel;

    this.portafoglioTableLabel = [];
    this.portafoglioTableData = [];
    this.raccomandazioniTableLabel = [];
    this.raccomandazioniTableData = [];
    this.richiesteTableLabel = [];
    this.richiesteTableData = [];
    this.listaRegoleStrumento = [];
    this.raccomandazioniTotalItems = 0;
    this.richiesteTotalItems = 0;
    this.pageNumber = 1;
    this.itemsPerPage = 10;
    this.statoPratiche = undefined;
    this.posizione = {};
    this.inserimentoOrdiniVisibile = false;
    this.domain = {
      listaTipologiaStrumento: [],
      listaStatoRaccomandazione: []
    };
    this.spinner = {
      listaPortafoglio: false,
      listaRaccomandazioni: false,
      listaRichieste: false
    };
    this.messaggiFctr.chiudiLoaderBrio();

    /*
     * -------------------------------------
     * START METODI PROMISE PER SERVIZI REST
     * -------------------------------------
     */

    /**
     * @ngdoc method
     * @name promiseCustomerData
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Effettua la chiamata per ricevere il customerdata
     * @return {Promise} - Ritorna una promise contenente il customerdata
     */
    this.promiseCustomerData = function () {
      return self.$http({
        method: 'GET',
        url: CONSTANTS.REST_CUSTOMER + CONSTANTS.REST.CUSTOMER_DOSSIER,
        params: {
          rapporto: self.$stateParams.finCodiceRapporto
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseDominioStrumento
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Effettua una chiamata http per ricevere la lista delle tipologie strumento
     * @return {Promise} - Ritorna una promise contenente i dati per popolare la select del filtro stato per la lista del saldo portafoglio
     */
    this.promiseDominioFiltriStrumento = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'categoriaStrumenti'
      });
    };

    /**
     * @ngdoc method
     * @name promiseDominioFiltri
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Effettua una chiamata http per ricevere la lista degli stati possibili di una raccomandazione
     * @return {Promise} - Ritorna una promise contenente i dati per popolare la select del filtro stato per la lista delle raccomandazioni
     */
    this.promiseDominioFiltriRaccomandazione = function () {
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          'statiRaccomandazione'
      });
    };

    /**
     * @ngdoc method
     * @name promiseDatiTabellaRaccomandazioni
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Effettua una chiamata http per ricevere la lista delle raccomandazioni associate ad un dossier
     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista delle raccomandazioni
     */
    this.promiseDatiTabellaRaccomandazioni = function () {
      self.spinner.listaRaccomandazioni = true;
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.DOSSIER +
          self.$stateParams.finCodiceRapporto +
          '/raccomandazioni',
        params: {
          limit: self.itemsPerPage,
          numeroPagina: self.pageNumber,
          statoPratiche: self.statoPratiche
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseDatiTabellaPortafoglio
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Effettua una chiamata http per ricevere la lista del portafoglio associate ad un dossier
     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista del portafoglio
     */
    this.promiseDatiTabellaPortafoglio = function () {
      self.spinner.listaPortafoglio = true;
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.STRUMENTO +
          self.$stateParams.finCodiceRapporto +
          '/saldi'
      });
    };

    /**
     * @ngdoc method
     * @name promiseDatiTabellaRichieste
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Effettua una chiamata http per ricevere la lista delle richieste associate ad un dossier
     * @return {Promise} - Ritorna una promise contenente i dati per popolare la lista delle richieste
     */
    this.promiseDatiTabellaRichieste = function () {
      self.spinner.listaRichieste = true;
      return self.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          self.$stateParams.finCodiceRapporto +
          '/richieste',
        params: {
          limit: self.itemsPerPage,
          numeroPagina: self.pageNumber,
          statoPratiche: self.statoPratiche
        }
      });
    };

    /**
     * @ngdoc method
     * @name promiseDatiTabellaRichieste
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Effettua una chiamata http per eliminare una raccomandazione
     * @param {Number} idRaccomandazione - Id della raccomandazione da eliminare
     * @return {Promise} - Ritorna una promise contenente il risultato dell'elimina raccomandazione
     */
    this.promiseEliminaRaccomandazione = function (idRaccomandazione) {
      return self.$http({
        method: 'DELETE',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.RACCOMANDAZIONE +
          idRaccomandazione
      });
    };

    /**
     * @ngod method
     * @name promiseRegoleStrumento
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Effettua una chiamata http per chiedere le regole delle operazioni
     * effettuabili dall'utente sul proprio saldoPortafoglio
     * @return {Promise} - Ritorna una lista di regole
     */
    this.promiseRegoleStrumento = function () {
      return this.$http({
        method: 'GET',
        url: CONSTANTS.REST_ROOT + CONSTANTS.REST.STRUMENTO + 'regoleStrumento'
      });
    };

    /*
     * -----------------------------------
     * END METODI PROMISE PER SERVIZI REST
     * -----------------------------------
     */

    /*
     * ------------------------
     * START INIT LABEL TABELLE
     * ------------------------
     */

    /**
     * @ngdoc method
     * @name initLabelTabellaRichieste
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRichiesteOrdine
     * @description Crea le label e la struttura della tabella delle richieste ordine
     */
    this.initLabelTabellaRichieste = function () {
      self.richiesteTableLabel = [
        {
          name: $scope.msg('lista.richieste.id.pratica'),
          field: 'idPratica',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.richieste.id.raccomandazione'),
          field: 'idRaccomandazione',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.richieste.codice.dossier'),
          field: 'codiceDossierTitoli',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.richieste.stato'),
          field: 'stato',
          width: '*',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: self.domain.listaStatoRaccomandazione
          }
        },
        {
          name: $scope.msg('lista.richieste.inserimento'),
          field: 'inserimento',
          cellFilter: 'date: "dd/MM/yyyy"',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.richieste.azione'),
          field: 'azione',
          width: 100,
          enableFiltering: false,
          cellTemplate:
            "<i class='fa fa-pencil fa-2x finIMargin finIPointer' ng-if=\"row.entity.stato === 'INCORSO' || row.entity.stato === 'CONSOLIDATA' || row.entity.stato === 'DAREVISIONARE' || (row.entity.stato === 'PRESENTATA' && grid.appScope.userSrvc.valutaPratica)\" aria-hidden='true' uib-tooltip=\"{{grid.appScope.msg('tooltip.modifica')}}\" tooltip-placement=\"left\" ng-click=\"grid.appScope.modificaRichiesta({richiesta: row.entity})\"></i>" +
            '<i class=\'fa fa-search fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaRichiesta({richiesta: row.entity})"></i>'
        }
      ];
    };

    /**
     * @ngdoc method
     * @name initLabelTabellaPortafoglio
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Crea le label e la struttura della tabella del portafoglio
     */
    this.initLabelTabellaPortafoglio = function () {
      self.portafoglioTableLabel = [
        {
          name: $scope.msg('lista.portafoglio.isin'),
          field: 'strumento.isin',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.intestatario'),
          field: 'intestatario',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.tipologia'),
          field: 'strumento.categoriaStrumento.descrizione',
          width: '*',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: self.domain.listaTipologiaStrumento
          }
        },
        {
          name: $scope.msg('lista.portafoglio.descrizione'),
          field: 'strumento.descrizione',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.divisa'),
          field: 'strumento.divisa',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.quantita.disponibile'),
          field: 'quantitaDisponibile',
          cellFilter: self.userSrvc.doppiaPrecisioneQuantita
            ? 'number : 6'
            : 'number : 3',
          cellClass: 'right',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.quantita'),
          field: 'quantita',
          cellFilter: self.userSrvc.doppiaPrecisioneQuantita
            ? 'number : 6'
            : 'number : 3',
          cellClass: 'right',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.ctv.euro'),
          field: 'valoreMercatoControvalore',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.rateo.netto.euro'),
          field: 'ctvRateoNettoEuro',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.rateo.lordo.euro'),
          field: 'ctvRateoLordoEuro',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.prezzo.mercato'),
          field: 'prezzoMercato',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.prezzo.medio'),
          field: 'prezzoCarico',
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          enableFiltering: false
        },
        {
          name: $scope.msg('lista.portafoglio.plus.min'),
          field: 'percPlusMinus',
          cellClass: 'right',
          width: '*',
          enableFiltering: false
        }
      ];
      if (
        self.$stateParams.finServizio === '2' &&
        self.userSrvc.inserimentoOrdiniVisibile
      ) {
        var cellTemplate =
          '<div style="line-height: 40px; ">' +
          '<i class=\'fa fa-plus fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni && !grid.appScope.userSrvc.mostraSoloVenditaOrdini" uib-tooltip="{{grid.appScope.msg(\'tooltip.acquista\')}}" tooltip-placement="left" ng-click="grid.appScope.acquista({itemPortafoglio: row.entity})"></i>' +
          '<i class=\'fa fa-minus fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni" uib-tooltip="{{grid.appScope.msg(\'tooltip.vendi\')}}" tooltip-placement="left" ng-click="grid.appScope.vendita({itemPortafoglio: row.entity})"></i>' +
          '<i class=\'fa fa-exchange fa-2x finIMargin finIPointer\' aria-hidden=\'true\' ng-if="row.entity.mostraBottoni && row.entity.strumento.categoriaStrumento.descrizione === \'Fondo\' && !grid.appScope.userSrvc.mostraSoloVenditaOrdini" uib-tooltip="{{grid.appScope.msg(\'tooltip.switch\')}}" tooltip-placement="left" ng-click="grid.appScope.cambio({itemPortafoglio: row.entity})"></i>';
        if (
          userSrvc.abilitato(CONSTANTS.ABILITAZIONI.MODIFICA_PIANO) ||
          userSrvc.isBpa
        ) {
          //operativitaPiani
          cellTemplate +=
            '<i class="fa fa-product-hunt fa-2x finIMargin finIPointer" aria-hidden="true" ' +
            ' ng-if="row.entity.mostraBottoni ' +
            ' && row.entity.operativitaPiani' +
            " && row.entity.strumento.categoriaStrumento.descrizione === 'Fondo' \"" +
            ' && !grid.appScope.userSrvc.mostraSoloVenditaOrdini" ' +
            'uib-tooltip="{{grid.appScope.msg(\'tooltip.piano\')}}" ' +
            'tooltip-placement="left" ng-click="grid.appScope.cambioPiano({itemPortafoglio: row.entity})"></i>';
        }
        cellTemplate += '</div>';

        self.portafoglioTableLabel.push({
          field: 'azioni',
          name: $scope.msg('lista.portafoglio.acquista.vendita'),
          width: 150,
          enableFiltering: false,
          cellTemplate: cellTemplate
        });
      }
    };

    /**
     * @ngdoc method
     * @name initLabelTabellaRaccomandazioni
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Crea le label e la struttura della tabella delle raccomandazioni
     */
    this.initLabelTabellaRaccomandazioni = function () {
      self.raccomandazioniTableLabel = [
        {
          name: $scope.msg('saldo.dossier.numero.raccomandazione'),
          field: 'idPratica',
          width: '*',
          enableFiltering: false
        },
        {
          name: $scope.msg('saldo.dossier.stato'),
          field: 'stato',
          width: '*',
          filter: {
            type: uiGridConstants.filter.SELECT,
            selectOptions: self.domain.listaStatoRaccomandazione
          }
        },
        {
          name: $scope.msg('saldo.dossier.data.inserimento'),
          width: '*',
          field: 'inserimento',
          cellFilter: 'date: "dd/MM/yyyy"',
          enableFiltering: false
        },
        {
          name: $scope.msg('saldo.dossier.data.scadenza'),
          width: '*',
          field: 'dataScadenzaRaccomandazione',
          cellFilter: 'date: "dd/MM/yyyy"',
          enableFiltering: false
        },
        {
          name: $scope.msg('saldo.dossier.ctv.teorico'),
          width: '*',
          cellFilter: 'number : 2',
          cellClass: 'right',
          field: 'controvaloreTeorico',
          enableFiltering: false
        },
        {
          field: 'azioni',
          name: $scope.msg('saldo.dossier.azioni'),
          width: 120,
          enableFiltering: false,
          cellTemplate:
            '<i class=\'fa fa-search fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.visualizza\')}}" tooltip-placement="left" ng-click="grid.appScope.visualizzaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>' +
            '<i class=\'fa fa-pencil fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'modifica\')" ng-click="grid.appScope.modificaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>' +
            '<i class=\'fa fa-trash fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.elimina\')}}" tooltip-placement="left" ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'elimina\')" ng-click="grid.appScope.eliminaRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>' +
            '<i class=\'fa fa-pencil fa-2x finIMargin finIPointer\' aria-hidden=\'true\' uib-tooltip="{{grid.appScope.msg(\'tooltip.modifica\')}}" tooltip-placement="left" ng-if="grid.appScope.finTableCtrl.showButtonRaccomandazioni(row.entity.stato, \'valutazione\')" ng-click="grid.appScope.valutazioneRaccomandazione({idRaccomandazione: row.entity.idPratica})"></i>'
        }
      ];
    };

    /*
     * ----------------------
     * END INIT LABEL TABELLE
     * ----------------------
     */

    /*
     * -----------------------
     * START METODI CONTROLLER
     * -----------------------
     */

    /**
     * @ngdoc method
     * @name apriModaleNuovaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Apre e gestisce il risultato della modale iniziativa
     */
    this.apriModaleNuovaRaccomandazione = function () {
      //			Se la banca ha già l'iniziativa settata e il profilo è un promotore non faccio vedere la modale
      if (self.userSrvc.iniziativaRaccomandazione) {
        self.$stateParams.finIniziativa =
          self.userSrvc.iniziativaRaccomandazione;
        self.nuovaRaccomandazione();
      } else {
        self.$uibModal
          .open({
            animation: true,
            templateUrl:
              CONSTANTS.BASE_ROOT +
              'widgets/finModali/iniziativa/finModaleIniziativa.html',
            controller: 'FinModaleIniziativaCtrl',
            controllerAs: 'modalCtrl',
            size: 'modal-lg'
          })
          .result.then(function (response) {
            self.$stateParams.finIniziativa = response;
            self.nuovaRaccomandazione();
          });
      }
    };

    /**
     * @ngdoc method
     * @name nuovaRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Naviga nello stato di creazione di un nuovo ordine in modalita acquista
     */
    this.nuovaRichiesta = function () {
      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name acquista
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Entra nello stato nuova richiesta con modalita acquista
     */
    this.acquista = function (itemPortafoglio) {
      self.$stateParams.acqven = $scope.msg('lista.proposte.a');
      self.$stateParams.finCodiceStrumento = itemPortafoglio.strumento.codice.trim();
      self.$stateParams.finIntestatarioStrumento =
        itemPortafoglio.ndgIntestatario;
      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name vendita
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Entra nello stato nuova richiesta con modalita vendita
     */
    this.vendita = function (itemPortafoglio) {
      self.$stateParams.acqven = $scope.msg('lista.proposte.d');
      self.$stateParams.finCodiceStrumento = itemPortafoglio.strumento.codice.trim();
      self.$stateParams.finIntestatarioStrumento =
        itemPortafoglio.ndgIntestatario;
      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name cambio
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Entra nello stato nuova proposta con modalita cambio
     */
    this.cambio = function (itemPortafoglio) {
      self.$stateParams.acqven = $scope.msg('lista.proposte.s');
      self.$stateParams.finCodiceStrumento = itemPortafoglio.strumento.codice.trim();
      self.$stateParams.finIntestatarioStrumento =
        itemPortafoglio.ndgIntestatario;
      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name cambioPiano
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Entra nello stato nuova proposta con modalita cambio
     */
    this.cambioPiano = function (itemPortafoglio) {
      self.$stateParams.acqven = CONSTANTS.OPERAZIONI.RIMODULAZIONE_PIANO;
      self.$stateParams.finCodiceStrumento = itemPortafoglio.strumento.codice.trim();
      self.$stateParams.finIntestatarioStrumento =
        itemPortafoglio.ndgIntestatario;
      self.$state.go(self.nuovaRichiestaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name modificaRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Naviga nello stato di modifica di una richiesta
     * @param {Object} richiesta - Richiesta da modificare
     */
    this.modificaRichiesta = function (richiesta) {
      self.$stateParams.finIdRaccomandazione = richiesta.idRaccomandazione;
      self.$stateParams.finIdRichiesta = richiesta.idPratica;
      self.$state.go(self.modificaRichiestaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name visualizzaRichiesta
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Naviga nello stato di visualizzazione di una richiesta
     * @param {Object} richiesta - Richiesta da visualizzare
     */
    this.visualizzaRichiesta = function (richiesta) {
      self.$stateParams.finIdRaccomandazione = richiesta.idRaccomandazione;
      self.$stateParams.finIdRichiesta = richiesta.idPratica;
      self.$state.go(self.visualizzaRichiestaState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name nuovaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Naviga nello stato di creazione di una raccomandazione
     */
    this.nuovaRaccomandazione = function () {
      self.$state.go(self.nuovaRaccomandazioneState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name modificaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Naviga nello stato di modifica di una raccomandazione
     * @param {Number} idRaccomandazione - Id della raccomandazione da modificare
     */
    this.modificaRaccomandazione = function (idRaccomandazione) {
      self.$stateParams.finIdRaccomandazione = idRaccomandazione;
      self.$state.go(self.modificaRaccomandazioneState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name visualizzaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Naviga nello stato di modifica di una raccomandazione
     * @param {Number} idRaccomandazione - Id della raccomandazione da visualizzare
     */
    this.visualizzaRaccomandazione = function (idRaccomandazione) {
      self.$stateParams.finIdRaccomandazione = idRaccomandazione;
      self.$state.go(self.visualizzaRaccomandazioneState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name visualizzaRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Elimina una raccomandazione da un dossier
     * @param {Number} idRaccomandazione - Id della raccomandazione da eliminare
     */
    this.eliminaRaccomandazione = function (idRaccomandazione) {
      self.promiseEliminaRaccomandazione(idRaccomandazione).then(
        function (response) {
          if (self.messaggiFctr.processaResponse(response)) {
            return;
          }
          self.$state.go(self.$state.current.name, self.$stateParams, {
            reload: true
          });
        },
        function (reason) {
          self.messaggiFctr.processaResponse(reason);
        }
      );
    };

    /**
     * @ngdoc method
     * @name valutazioneRaccomandazione
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Entra nello stato di valutazione di una raccomandazione
     * @param {Number} idRaccomandazione - Id della raccomandazione da valutare
     */
    this.valutazioneRaccomandazione = function (idRaccomandazione) {
      self.$stateParams.finIdRaccomandazione = idRaccomandazione;
      self.$state.go(self.valutazioneRaccomandazioneState, self.$stateParams);
    };

    /**
     * @ngdoc method
     * @name back
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Ritorna alla rotta della sceltaDossier
     */
    this.back = function () {
      if (self.deskSrvc.isDesk) {
        self.deskSrvc.popEntry();
      }
      if(sessionStorage.getItem('isFromSchedaDossier')){
        sessionStorage.removeItem('isFromSchedaDossier');
        self.$state.go('schedaDossier', self.$stateParams);
      }else{
        self.$state.go(self.sceltaDossierState, self.$stateParams);
      }
      
    };

    /**
     * @ngdoc method
     * @name aggiornaLista
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Chiama la promise e gestisce i dati per la lista raccomandazioni e richieste
     */
    this.aggiornaLista = function () {
      if (self.$stateParams.finServizio === '1') {
        self
          .promiseDatiTabellaRaccomandazioni()
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                return;
              }
              self.raccomandazioniTotalItems =
                response.data.result.numeroRecord;
              self.raccomandazioniTableData =
                response.data.result.listaRisultati;
            },
            function (reason) {
              self.messaggiFctr.processaResponse(reason);
            }
          )
          .finally(function () {
            self.spinner.listaRaccomandazioni = false;
          });
      } else {
        self
          .promiseDatiTabellaRichieste()
          .then(
            function (response) {
              if (self.messaggiFctr.processaResponse(response)) {
                return;
              }
              self.richiesteTotalItems = response.data.result.numeroRecord;
              self.richiesteTableData = response.data.result.listaRisultati;
            },
            function (reason) {
              self.messaggiFctr.processaResponse(reason);
            }
          )
          .finally(function () {
            self.spinner.listaRichieste = false;
          });
      }
    };

    /**
     * @ngodc method
     * @name cambioPaginaTabella
     * @methodOf cbl.finanza.mf.directive:finanzaGestioneRaccomandazione
     * @description Cambia il numero di pagina e il numero di elementi per pagina
     */
    this.cambioPaginaTabella = function (pageNumber, itemsPerPage) {
      self.itemsPerPage = itemsPerPage;
      self.pageNumber = pageNumber;
      self.aggiornaLista();
    };

    /**
     * @ngdoc method
     * @name applicaFiltri
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Applica il filtro STATO della tabella raccomandazioni o richieste
     * @param {Object} columns - Tutta la struttura delle colonne
     */
    this.applicaFiltri = function (columns) {
      self.statoPratiche = columns[2].filters[0].term;
      self.aggiornaLista();
    };

    /**
     * @ngdoc method
     * @name checkRegoleStrumento
     * @methodOf cbl.finanza.mf.directive:finanzaSaldoDossier
     * @description Gestisce l'array del saldoPortafoglio e decide
     * se mostrare o meno i bottoni di Acquisto, Vendita e Switch
     */
    this.checkRegoleStrumento = function () {
      self.portafoglioTableData.forEach(function (portafoglio) {
        //				Imposta la proprietà mostraBottoniPortafoglio per ciascun saldo in base alle regole dello strumento
        portafoglio['mostraBottoni'] = self.listaRegoleStrumento.some(function (
          regola
        ) {
          var ruolo = false;
          //					Se siamo in brio forkato le logiche cambiano
          if (self.brioSrvc.brioVersion === 'brio-xc') {
            //						Se siamo in filiale effettuo un controllo diverso rispetto a promotore
            if (self.userSrvc.canaleOperativo === 'filialefxc') {
              ruolo =
                !regola.ruolo ||
                regola.ruolo.toLowerCase().trim() === 'filiale';
            } else {
              ruolo =
                !regola.ruolo || regola.ruolo.toLowerCase().trim() === 'brio';
            }
          } else {
            //						Se siamo in brio vecchio controllo su un altro campo
            ruolo =
              !regola.ruolo ||
              regola.ruolo.toLowerCase().trim() ===
                self.userSrvc.user.app.toLowerCase().trim();
          }
          var categoria =
            (!regola.categoria ||
              regola.categoria.toLowerCase().trim() ===
                portafoglio.strumento.categoriaStrumento.codice
                  .toLowerCase()
                  .trim()) &&
            regola.categoria.toLowerCase().trim() !== 'pog';
          var isin =
            !regola.isin ||
            regola.isin.toLowerCase().trim() ===
              portafoglio.strumento.isin.toLowerCase().trim();
          var emittente =
            !regola.emittente ||
            regola.emittente.toLowerCase().trim() ===
              portafoglio.strumento.emittente.toLowerCase().trim();
          return ruolo && categoria && isin && emittente;
        });
      });
    };

    /*
     * ---------------------
     * END METODI CONTROLLER
     * ---------------------
     */

    /*
     * ----------------------------
     * START METODI INIT CONTROLLER
     * ----------------------------
     */

    // Chiamo il getDossier per inserire le info nel customerdata
    self.promiseCustomerData().then(
      function (response) {
        if (self.messaggiFctr.processaResponse(response)) {
          self.posizione = {};
          return;
        }
        self.posizione = response.data;
      },
      function (reason) {
        self.messaggiFctr.processaResponse(reason);
      }
    );

    if (self.$stateParams.finServizio === '1') {
      $q.all({
        filtriRaccomandazione: self.promiseDominioFiltriRaccomandazione(),
        filtriStrumento: self.promiseDominioFiltriStrumento(),
        raccomandazioni: self.promiseDatiTabellaRaccomandazioni(
          self.pageNumber
        ),
        portafoglio: self.promiseDatiTabellaPortafoglio(),
        label: labelSrvc.labelsPronte
      })
        .then(
          function (response) {
            if (
              self.messaggiFctr.processaResponse(
                response.filtriRaccomandazione
              ) ||
              self.messaggiFctr.processaResponse(response.filtriStrumento) ||
              self.messaggiFctr.processaResponse(response.raccomandazioni) ||
              self.messaggiFctr.processaResponse(response.portafoglio)
            ) {
              self.domain.listaStatoRaccomandazione = [];
              self.domain.listaTipologiaStrumento = [];
              self.raccomandazioniTableData = [];
              self.initLabelTabellaRaccomandazioni();
              self.portafoglioTableData = [];
              return;
            }
            response.filtriRaccomandazione.data.result.forEach(function (item) {
              self.domain.listaStatoRaccomandazione.push({
                label: item,
                value: item
              });
            });
            response.filtriStrumento.data.result.forEach(function (item) {
              self.domain.listaTipologiaStrumento.push({
                label: item.descrizione,
                value: item.descrizione
              });
            });
            self.initLabelTabellaRaccomandazioni();
            self.initLabelTabellaPortafoglio();
            self.raccomandazioniTotalItems =
              response.raccomandazioni.data.result.numeroRecord;
            self.raccomandazioniTableData =
              response.raccomandazioni.data.result.listaRisultati;
            self.portafoglioTableData = response.portafoglio.data.result;
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason.filtriRaccomandazione);
            self.messaggiFctr.processaResponse(reason.filtriStrumento);
            self.messaggiFctr.processaResponse(reason.raccomandazioni);
            self.messaggiFctr.processaResponse(reason.portafoglio);
            self.domain.listaStatoRaccomandazione = [];
            self.domain.listaTipologiaStrumento = [];
            self.raccomandazioniTableData = [];
            self.portafoglioTableData = [];
          }
        )
        .finally(function () {
          self.spinner.listaPortafoglio = false;
          self.spinner.listaRaccomandazioni = false;
        });
    } else {
      $q.all({
        richieste: self.promiseDatiTabellaRichieste(),
        portafoglio: self.promiseDatiTabellaPortafoglio(),
        filtriRaccomandazione: self.promiseDominioFiltriRaccomandazione(),
        filtriStrumento: self.promiseDominioFiltriStrumento(),
        regoleStrumento: self.promiseRegoleStrumento(),
        label: labelSrvc.labelsPronte
      })
        .then(
          function (response) {
            if (
              self.messaggiFctr.processaResponse(
                response.filtriRaccomandazione
              ) ||
              self.messaggiFctr.processaResponse(response.richieste) ||
              self.messaggiFctr.processaResponse(response.portafoglio) ||
              self.messaggiFctr.processaResponse(response.filtriStrumento) ||
              self.messaggiFctr.processaResponse(response.regoleStrumento)
            ) {
              self.domain.listaStatoRaccomandazione = [];
              self.richiesteTableData = [];
              self.portafoglioTableData = [];
              self.domain.listaTipologiaStrumento = [];
              self.listaRegoleStrumento = [];
              return;
            }
            response.filtriRaccomandazione.data.result.forEach(function (item) {
              self.domain.listaStatoRaccomandazione.push({
                label: item,
                value: item
              });
            });
            response.filtriStrumento.data.result.forEach(function (item) {
              self.domain.listaTipologiaStrumento.push({
                label: item.descrizione,
                value: item.codice
              });
            });
            self.richiesteTotalItems =
              response.richieste.data.result.numeroRecord;
            self.richiesteTableData =
              response.richieste.data.result.listaRisultati;
            self.portafoglioTableData = response.portafoglio.data.result;
            self.listaRegoleStrumento = response.regoleStrumento.data.result;
            self.checkRegoleStrumento();
            self.initLabelTabellaRichieste();
            self.initLabelTabellaPortafoglio();
          },
          function (reason) {
            self.messaggiFctr.processaResponse(reason.filtriRaccomandazione);
            self.messaggiFctr.processaResponse(reason.richieste);
            self.messaggiFctr.processaResponse(reason.portafoglio);
            self.messaggiFctr.processaResponse(reason.filtriStrumento);
            self.messaggiFctr.processaResponse(reason.regoleStrumento);
            self.domain.listaStatoRaccomandazione = [];
            self.domain.listaTipologiaStrumento = [];
            self.richiesteTableData = [];
            self.portafoglioTableData = [];
            self.listaRegoleStrumento = [];
          }
        )
        .finally(function () {
          self.spinner.listaPortafoglio = false;
          self.spinner.listaRichieste = false;
        });
    }

    if (self.deskSrvc.isDesk) {
      labelSrvc.labelsPronte.then(function () {
        self.deskSrvc.aggiungiEntry(
          labelSrvc.getLabel('saldo.dossier.posizione.cliente')
        );
      });
    }
    /*
     * --------------------------
     * END METODI INIT CONTROLLER
     * --------------------------
     */
  };

  SaldoDossierCtrl.$inject = [
    '$http',
    '$scope',
    '$window',
    '$q',
    '$stateParams',
    '$state',
    '$location',
    'FIN_CONSTANTS',
    'FinLabelSrvc',
    'FinMessaggiFctr',
    'uiGridConstants',
    'CblMessageSrvc',
    'FinUserSrvc',
    '$uibModal',
    'FinBrioSrvc',
    'FinDeskSrvc'
  ];

  var TemplateUrl = function (CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'saldoDossier/saldoDossier.html'
    );
  };
  TemplateUrl.$inject = ['FIN_CONSTANTS'];

  var SaldoDossierComponent = {
    bindings: {
      sceltaDossierState: '@',
      visualizzaRaccomandazioneState: '@',
      modificaRaccomandazioneState: '@',
      nuovaRaccomandazioneState: '@',
      valutazioneRaccomandazioneState: '@',
      modificaRichiestaState: '@',
      nuovaRichiestaState: '@',
      visualizzaRichiestaState: '@'
    },
    controller: SaldoDossierCtrl,
    controllerAs: 'saldoDossierCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.finanza.mf')
    .component('finanzaSaldoDossier', SaldoDossierComponent);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/saldoDossier/saldoDossier.cmpt.js
 ** module id = 16
 ** module chunks = 0 1 2
 **/